export const IS_CREATE_SIZE = "IS_CREATE_SIZE";
export const IS_UPDATE_SIZE = "IS_UPDATE_SIZE";
export const SIZE_LIST = "SIZE_LIST";
export const AFTER_CREATED = "AFTER_CREATED";
export const AFTER_UPDATED = "AFTER_UPDATED";
export const AFTER_DELETED = "AFTER_DELETED";
